import { render, staticRenderFns } from "./EditBillsItem.vue?vue&type=template&id=27b67f44&scoped=true&"
import script from "./EditBillsItem.vue?vue&type=script&lang=js&"
export * from "./EditBillsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b67f44",
  null
  
)

export default component.exports